import { CollectDataStepCreateReason } from 'src/constants/contractor/enums'

export const GIGSAFE_API_LABEL = 'GigSafe API'

export const RECOLLECTION_REASON_MESSAGES: Partial<Record<CollectDataStepCreateReason, string>> = {
  [CollectDataStepCreateReason.ManualRecollection]: 'Recollection triggered manually.',
  [CollectDataStepCreateReason.NewTemplateStep]:
    'Manual. Recollection started due to onboarding flow changes.',
  [CollectDataStepCreateReason.TemplateUpdates]:
    'Manual. Recollection started due to onboarding flow changes.',
  [CollectDataStepCreateReason.Declined]: 'Manual. Recollection started due to submission decline.',
}
